import { render, staticRenderFns } from "./channelForm.vue?vue&type=template&id=dc6c0d6a&scoped=true&"
import script from "./channelForm.vue?vue&type=script&lang=js&"
export * from "./channelForm.vue?vue&type=script&lang=js&"
import style0 from "./channelForm.vue?vue&type=style&index=0&id=dc6c0d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6c0d6a",
  null
  
)

export default component.exports